import { application } from "./application"

import AddSponsorController from "./add_sponsor_controller"
import AskSavantController from "./ask_savant_controller"
import AutocompleteController from "./autocomplete_controller"
import BoardLayoutController from "./board_layout_controller"
import BulkSelectController from "./bulk_select_controller"
import ChartController from "./chart_controller"
import ClipboardController from "./clipboard_controller"
import ClockController from "./clock_controller"
import CommandPaletteController from "./command_palette_controller"
import DetailsMemoryController from "./details_memory_controller"
import DownloadButtonController from "./download_button_controller"
import DropdownPopoverController from "./dropdown_popover_controller"
import KanbanController from "./kanban_controller"
import ModalController from "./modal_controller"
import PullToRefreshController from "./pull_to_refresh_controller"
import PwaController from "./pwa_controller"
import QueueStatusController from "./queue_status_controller"
import SidebarController from "./sidebar_controller"
import SlideoverController from "./slideover_controller"
import StepperController from "./stepper_controller"
import TabsController from "./tabs_controller"
import TaskReviewController from "./task_review_controller"
import ThemeController from "./theme_controller"
import TiptapEditorController from "./tiptap_editor_controller"
import ToastController from "./toast_controller"

application.register("add-sponsor", AddSponsorController)
application.register("ask-savant", AskSavantController)
application.register("autocomplete", AutocompleteController)
application.register("board-layout", BoardLayoutController)
application.register("bulk-select", BulkSelectController)
application.register("chart", ChartController)
application.register("clipboard", ClipboardController)
application.register("clock", ClockController)
application.register("command-palette", CommandPaletteController)
application.register("details-memory", DetailsMemoryController)
application.register("download-button", DownloadButtonController)
application.register("dropdown-popover", DropdownPopoverController)
application.register("kanban", KanbanController)
application.register("modal", ModalController)
application.register("pull-to-refresh", PullToRefreshController)
application.register("pwa", PwaController)
application.register("queue-status", QueueStatusController)
application.register("sidebar", SidebarController)
application.register("slideover", SlideoverController)
application.register("stepper", StepperController)
application.register("tabs", TabsController)
application.register("task-review", TaskReviewController)
application.register("theme", ThemeController)
application.register("tiptap-editor", TiptapEditorController)
application.register("toast", ToastController)
